<template>
  <li @click="chooseSelect" class="s-item over ">
    <span class="s-item-l">
      <i v-if="icon" :class="icon" class="icon"></i>
      {{ label }}
    </span>
    <span v-if="rLabel" class="s-item-r">{{ rLabel }} </span>
  </li>
</template>
<script>
import Emitter from "@/utils/emitter";
export default {
  name: "ByOption",
  componentName: 'ByOption',


  mixins: [Emitter],

  props: {
    icon: { type: String },
    label: { type: String },
    rLabel: { type: String }, //右边文字 先暂时这样处理
    value: { type: String },
    item: { type: Object }
  },
  created() {},
  methods: {
    chooseSelect() {
      let curVal = {
        label: this.label,
        value: this.value,
        item: this.item
      };
      // 传参数到BySelect
      this.dispatch("BySelect", "curOptVal", curVal);
    },
  },
};
</script>
<style scoped>
.s-item {
  cursor: pointer;
  color: #555;
  line-height: 30px;
  font-size: 13px;
  padding: 0 5px;
  font-size: 12px;
}
.s-item:hover{
  background: #f0f0f0;
}
</style>


// WEBPACK FOOTER //
// src/components/Reception/public/byOption.vue